module.exports = __webpack_public_path__ + "pigmentace_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_4_after_tn.jpg
// module id = 1443
// module chunks = 0